export function numberToCurrencyNo(value) {
  // 千位符过滤
  if (!value) return 0;
  // 获取整数部分
  const intPart = Math.trunc(value);
  // 整数部分处理，增加,
  const intPartFormat = intPart.toString().replace(/(\d)(?=(?:\d{3})+$)/g, '$1,');
  // 预定义小数部分
  let floatPart = '';
  // 将数值截取为小数部分和整数部分
  const valueArray = value.toString().split('.');
  if (valueArray.length === 2) {
    // 有小数部分
    floatPart = valueArray[1].toString(); // 取得小数部分
    return intPartFormat + '.' + floatPart;
  }
  return intPartFormat + floatPart;
}

// 围栏型号过滤
export function modelchangeFilter(type) {
  if (!type) return '';
  const arr = type.split('-');
  return `T-${arr[0]}アルミ柱 + T-${arr[0]}ボード(${arr[1]}段貼)`;
}
/**
 *解决两个数相加精度丢失问题
 *@param a
 *@param b
 *@returns {Number}
 */
export function floatAdd(a, b) {
  var c, d, e;
  if (undefined == a || null == a || '' == a || isNaN(a)) {
    a = 0;
  }
  if (undefined == b || null == b || '' == b || isNaN(b)) {
    b = 0;
  }
  try {
    c = a.toString().split('.')[1].length;
  } catch (f) {
    c = 0;
  }
  try {
    d = b.toString().split('.')[1].length;
  } catch (f) {
    d = 0;
  }
  e = Math.pow(10, Math.max(c, d));
  return (floatMul(a, e) + floatMul(b, e)) / e;
}
/**
 *解决两个数相减精度丢失问题
 *@param a
 *@param b
 *@returns {Number}
 */
export function floatSub(a, b) {
  var c, d, e;
  if (undefined == a || null == a || '' == a || isNaN(a)) {
    a = 0;
  }
  if (undefined == b || null == b || '' == b || isNaN(b)) {
    b = 0;
  }
  try {
    c = a.toString().split('.')[1].length;
  } catch (f) {
    c = 0;
  }
  try {
    d = b.toString().split('.')[1].length;
  } catch (f) {
    d = 0;
  }
  e = Math.pow(10, Math.max(c, d));
  return (floatMul(a, e) - floatMul(b, e)) / e;
}
/**
 *解决两个数相乘精度丢失问题
 *@param a
 *@param b
 *@returns {Number}
 */
export function floatMul(a, b) {
  var c = 0,
    d = a.toString(),
    e = b.toString();
  try {
    c += d.split('.')[1].length;
  } catch (f) {}
  try {
    c += e.split('.')[1].length;
  } catch (f) {}
  return (Number(d.replace('.', '')) * Number(e.replace('.', ''))) / Math.pow(10, c);
}
/**
 *解决两个数相除精度丢失问题
 *@param a
 *@param b
 *@returns
 */
export function floatDiv(a, b) {
  var c,
    d,
    e = 0,
    f = 0;
  try {
    e = a.toString().split('.')[1].length;
  } catch (g) {}
  try {
    f = b.toString().split('.')[1].length;
  } catch (g) {}
  return (c = Number(a.toString().replace('.', ''))), (d = Number(b.toString().replace('.', ''))), floatMul(c / d, Math.pow(10, f - e));
}
